
  // Export
  module.exports =
  {

    // Edit scripts
    edit:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Get the password script
        $.getScript(APPLICATION._PATH_PREFIX + 'includes/js/password.js?v=' + APPLICATION._PASSWORD_VERSION, function ()
        {

          // On generating the password
          $('#generate_password').not('.js-ignore').click(function ()
          {

            // Generate the password
            PasswordGenerator.generate(function (password)
            {
          
              // Show the generated password
              $('#generated_password').val(password)
          
              // Enter the password
              $('#password').val(password)

            }
            )

          }
          ).addClass('js-ignore')

        }
        )

        // On clicking the generated password
        $('#generated_password').not('.js-ignore').click(function ()
        {
          this.select()
        }
        ).addClass('js-ignore')
     
      }

    },

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#accounts'), APPLICATION._PATH_PREFIX + 'account/accounts', 'Account', 'accounts')        
      }

    },

    // Accounts scripts
    accounts:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#accounts', 'Account', 'accounts')
      }

    },

    // Re-sign in scripts
    reSignIn:
    {

      // The args
      args: [],

      // Signed in
      signedIn: function ()
      {

        // Remove the modal
        $('body').removeClass('show-modal')

        // Run the callback
        this.callback.apply(null, this.args)

      }

    }

  }